import { z } from "zod";
import { StatusOk } from "../_core.js";
export const MeterReading = z
    .object({
    id: z.string(),
    customerNo: z.string(),
    customerPhoneNo: z.string(),
    customerEmail: z.string(),
    date: z.string(),
    time: z.string(),
    method: z.enum(["WEB", "SMS"]),
    meterReading: z.number(),
    outgoingMessage: z.boolean(),
    outgoingText1: z.string(),
    outgoingText2: z.string(),
})
    .meta({ ref: "MeterReading" });
export const Consumption = z
    .object({
    id: z.string(),
    customerNo: z.string(),
    readingDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    meterReading: z.number(),
    newMeter: z.boolean(),
    estimate: z.boolean(),
})
    .meta({ ref: "Consumption" });
export const CreateMeterReadingRequestBody = Consumption.pick({
    readingDate: true,
    meterReading: true,
}).meta({ ref: "CreateMeterReadingRequestBody" });
export const CreateMeterReadingResponseBody = StatusOk.meta({
    ref: "CreateMeterReadingResponseBody",
});
export const ListMeterReadingsRequestSearchParams = z
    .object({
    dateFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    dateTo: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
})
    .meta({ ref: "ListMeterReadingsRequestSearchParams" });
export const ListMeterReadingsResponseBody = z
    .object({
    meterReadings: z.array(MeterReading.pick({
        id: true,
        customerNo: true,
        date: true,
        time: true,
        meterReading: true,
    })),
})
    .meta({ ref: "ListMeterReadingsResponseBody" });
export const ListConsumptionsRequestSearchParams = z
    .object({
    dateFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    dateTo: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
})
    .meta({ ref: "ListConsumptionsRequestSearchParams" });
export const ListConsumptionsResponseBody = z
    .object({
    consumptions: z.array(Consumption),
})
    .meta({ ref: "ListConsumptionsResponseBody" });
